/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_Duration_LimitsInputs */

const en_admin_resource_form_booking_duration_limits = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking Duration Limits`)
};

const de_admin_resource_form_booking_duration_limits = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungsdauer`)
};

const es_admin_resource_form_booking_duration_limits = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Límites de duración de la reserva`)
};

const fr_admin_resource_form_booking_duration_limits = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limites de durée de réservation`)
};

const nl_admin_resource_form_booking_duration_limits = /** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserveringsduur`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */
const it_admin_resource_form_booking_duration_limits = en_admin_resource_form_booking_duration_limits;

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_duration_limits = en_admin_resource_form_booking_duration_limits;

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */
const pl_admin_resource_form_booking_duration_limits = en_admin_resource_form_booking_duration_limits;

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */
const hu_admin_resource_form_booking_duration_limits = en_admin_resource_form_booking_duration_limits;

/** @type {(inputs: Admin_Resource_Form_Booking_Duration_LimitsInputs) => LocalizedString} */
const ro_admin_resource_form_booking_duration_limits = en_admin_resource_form_booking_duration_limits;

/**
* | output |
* | --- |
* | "Booking Duration Limits" |
*
* @param {Admin_Resource_Form_Booking_Duration_LimitsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_duration_limits = /** @type {((inputs?: Admin_Resource_Form_Booking_Duration_LimitsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_Duration_LimitsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_duration_limits(inputs)
	if (locale === "de") return de_admin_resource_form_booking_duration_limits(inputs)
	if (locale === "es") return es_admin_resource_form_booking_duration_limits(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_duration_limits(inputs)
	if (locale === "nl") return nl_admin_resource_form_booking_duration_limits(inputs)
	if (locale === "it") return it_admin_resource_form_booking_duration_limits(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_duration_limits(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_duration_limits(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_duration_limits(inputs)
	return ro_admin_resource_form_booking_duration_limits(inputs)
});
export { admin_resource_form_booking_duration_limits as "admin.resource_form.booking_duration_limits" }